import { render, staticRenderFns } from "./IntegratedSearchResult.vue?vue&type=template&id=b4ef4f08&scoped=true"
import script from "./IntegratedSearchResult.vue?vue&type=script&lang=js"
export * from "./IntegratedSearchResult.vue?vue&type=script&lang=js"
import style0 from "./IntegratedSearchResult.vue?vue&type=style&index=0&id=b4ef4f08&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ef4f08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4ef4f08')) {
      api.createRecord('b4ef4f08', component.options)
    } else {
      api.reload('b4ef4f08', component.options)
    }
    module.hot.accept("./IntegratedSearchResult.vue?vue&type=template&id=b4ef4f08&scoped=true", function () {
      api.rerender('b4ef4f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/IntegratedSearchResult.vue"
export default component.exports